module.exports = __webpack_public_path__ + "assets/img/texing_icon_01@2x.136d54e2.png";